import { render, staticRenderFns } from "./AboutMe.vue?vue&type=template&id=456de12a&scoped=true"
import script from "./AboutMe.vue?vue&type=script&lang=js"
export * from "./AboutMe.vue?vue&type=script&lang=js"
import style0 from "./AboutMe.vue?vue&type=style&index=0&id=456de12a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "456de12a",
  null
  
)

export default component.exports